export const NewsletterStatusesMap: { [key: number]: string } = {
	1301: `Adres email jest niepoprawny`,
	1302: `Lista subskrypcyjna nie istnieje lub brak hash'a listy`,
	1303: `Jedno lub więcej pól dodatkowych jest niepoprawne`,
	1304: `Subskrybent już istnieje w tej liście subskrypcyjnej i ma status Aktywny lub Do aktywacji`,
	1305: `Próbowano nadać niepoprawny status subskrybenta`,
	1333: `Subskrybent jest na czarnej liście`,
};
